import {
    OBTENER_LLAVES,
    GET_CONFIG_FORMINF,
    GET_TIPOS_INFORME_PROF,
    GET_GESTOR,
    GET_ESTADOS,
    GET_RESPONSABLES,
    GET_CRITERIOS_FECHA_PROF,
    GET_INFORMES_PREVIOS_PROF,
    POST_GENERAR_INFORME_PROF
} from '../types';


export default function informesProfesionalesReducer(state = {}, action) {
    switch (action.type) {
        case OBTENER_LLAVES:
            return { ...state, llaves: action.payload }
        case GET_CONFIG_FORMINF:
            return { ...state, cfg_formInf: action.payload }
        case GET_TIPOS_INFORME_PROF:
            return { ...state, tiposInforme: action.payload }
        case GET_GESTOR:
            return { ...state, gestores: action.payload }
        case GET_ESTADOS:
            return { ...state, estados: action.payload }
        case GET_RESPONSABLES:
            return { ...state, responsables: action.payload }
        case GET_CRITERIOS_FECHA_PROF:
            return { ...state, criteriosFecha: action.payload }
        case GET_INFORMES_PREVIOS_PROF:
            return { ...state, listaInformesPrevios: action.payload }
        case POST_GENERAR_INFORME_PROF:
            return { ...state, respuestaGenerar: action.payload }
        default:
            return state
    }
}